import { Pipe, PipeTransform } from '@angular/core';

import { AppConstants } from '../../app.constants';
import { AuthDataInterface } from '../../core/models/view-models/account-models/auth-data.interface';

@Pipe({
    name: 'isInRole'
})
export class IsInRolePipe implements PipeTransform {

    transform(role: string, isToReverse: boolean = false): boolean {

        const authData: AuthDataInterface = JSON.parse(localStorage.getItem(AppConstants.AUTH_DATA_NAME));
        if (authData && authData.roles) {
            const roles: string[] = authData.roles.split(',');
            if (!isToReverse) {
                return roles.includes(role);
            } else {
                return !(roles.length === 1 && roles.includes(role));
            }
        }
        return false;
    }
}
